import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EntrepreneurProspectApplication } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, appService: AppService, domainData: DomainDataService) {

	const columns: GridColumn<EntrepreneurProspectApplication, unknown>[] = [
		buildColumn(util, 'Id', row => row.accApplicationId),
		buildColumn(util, 'Text', row => appService.getTrimesterNameById(row.trimesterId), { header: 'Trimester' }),
		buildColumn(util, 'Text', row => domainData.data().accApplicationStatusesMap[row.accApplicationStatusId]?.name, { header: 'Status' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created On' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.submittedUTC), { header: 'Submitted On' }),
		buildColumn(util, 'YesNo', row => row.isDeferred, { header: 'Deferred' }),
	];


	return columns;

}